import { Component, Input } from '@angular/core';
import { getAssetUrl } from '../shared/asset';
import { Theme } from '../theme/theme';
import { Gift } from './gift';

@Component({
    selector: 'app-gift',
    templateUrl: './gift.component.html',
    styleUrls: ['./gift.component.scss'],
    standalone: false
})
export class GiftComponent {
  @Input() gift: Gift;
  @Input() theme: Theme;
  @Input() mode: 'shop' | 'profile';
  @Input() isSelected = false;

  get src() {
    return getAssetUrl(this.gift.image.path);
  }

  get imageStyle() {
    return {
      'background-color': this.theme.backgroundColor
    };
  }

  get primaryBackgroundStyle() {
    return {
      'background-color': this.theme.primaryColor
    };
  }

  get selectedBoxStyle() {
    return {
      border: `2px solid ${this.theme.primaryColor}`
    };
  }
}
